export enum HorseRaceSortingDirection {
    Odds = 'odds',
    CardNumber = 'card-number',
    StarRating = 'star-rating',
    AtoZ = 'AtoZ',
}
